import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { ClerkAuthService } from '../services/clerk-auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const clerkAuthService = inject(ClerkAuthService);

  // N'ajoute le token que pour les routes protégées
  const isProtectedRoute = req.url.includes('/admin-api/');

  if (!isProtectedRoute) {
    return next(req);
  }

  return from(clerkAuthService.getToken()).pipe(
    switchMap((token) => {
      if (!token) {
        return next(req);
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(authReq);
    }),
  );
};